// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gMat","newExpiryDate":"styles_newExpiryDate__2io0Y","footer":"styles_footer__3I63s"};